import React, { useEffect, useState } from "react";
import { Container } from "./styled";

const DateRangePicker = ({ onStartDateChange, onEndDateChange }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endDateForInput, setEndDateForInput] = useState(null);
  const [startDateForInput, setStartDateForInput] = useState(null);
  const [isPopUpActive, setIsPopUpActive] = useState(false);
  let popUp = document.getElementById("date-pop-up");
  let isActive = popUp?.classList.contains("active");

  useEffect(() => {
    if (isActive) {
      disableScroll(document.body);
      setIsPopUpActive(true);
    } else if (!isActive || !isPopUpActive) {
      enableScroll(document.body);
    }
    return () => {
      enableScroll(document.body); // Re-enable scrolling when the component is unmounted
    };
  }, [isActive, isPopUpActive]);

  const handleStartDateChange = (e) => {
    let newDate = new Date(e.target.value);
    if (e === null) {
      setStartDate(null);
      setStartDateForInput(null);
    } else {
      setStartDate(new Date(e.target.value));
      setStartDateForInput(e.target.value);
    }
  };

  const handleEndDateChange = (e) => {
    if (e === null) {
      setEndDate(null);
      setEndDateForInput(null);
    } else {
      setEndDate(new Date(e.target.value));
      setEndDateForInput(e.target.value);
    }
  };
  const submitDates = () => {
    //document.getElementById("season-select").selectedIndex = 0;
    popUp.classList.remove("active");
    onStartDateChange(startDate); // Call the callback function to pass the updated start date to the parent component
    onEndDateChange(endDate); // Call the callback function to pass the updated end date to the parent component
    let seasonOptions = document.getElementsByClassName("theme-select")[0];
    //seasonOptions.classList.remove("active");
    setIsPopUpActive(false);
  };

  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  // call this to Disable
  function disableScroll() {
    window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
    window.addEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener("touchmove", preventDefault, wheelOpt);
    window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
  }
  return (
    <Container>
      <div className="header flex_center_space-between">
        <h4>Selecciona un Período</h4>
        <button
          className="btn-primary ghost"
          onClick={(e) => {
            handleStartDateChange(null);
            handleEndDateChange(null);
            let popUp = document.getElementById("date-pop-up");
            popUp.classList.remove("active");
            document.getElementById("season-select").selectedIndex = 0;
            setIsPopUpActive(false);
          }}
        >
          X
        </button>
      </div>
      <div>
        <label htmlFor="start-date">Fecha inicial:</label>
        <input
          type="date"
          pattern="\d{1,2}/\d{1,2}/\d{4}"
          id="start-date"
          value={startDateForInput}
          onChange={handleStartDateChange}
        />
      </div>
      <div>
        <label htmlFor="end-date">Fecha final:</label>
        <input
          type="date"
          id="end-date"
          placeholder="dd/mm/aaaa"
          value={endDateForInput}
          onChange={handleEndDateChange}
        />
      </div>
      <button
        className="btn-primary"
        onClick={(e) => {
          submitDates();
        }}
      >
        Finalizar
      </button>
    </Container>
  );
};

export default DateRangePicker;
